/* Albatross x Hemisphere — shared behaviours for hm-* sections */
(() => {
  if (!customElements.get('hm-video')) {
    class HmVideo extends HTMLElement {
      connectedCallback() {
        if (this._init) { this._observe(); return; }
        this.video = this.querySelector('video');
        if (!this.video) return;
        this._init = true;
        this.playBtn = this.querySelector('.hm-video__play');
        this.soundBtn = this.querySelector('.hm-video__sound');
        this.timeline = this.querySelector('.hm-video__timeline');
        this.playBtn && this.playBtn.addEventListener('click', () => this.toggle());
        this.soundBtn && this.soundBtn.addEventListener('click', (e) => { e.stopPropagation(); this.toggleSound(); });
        this.video.addEventListener('click', () => this.toggle());
        if (this.timeline) this.video.addEventListener('timeupdate', () => {
          const p = this.video.duration ? (this.video.currentTime / this.video.duration) * 100 : 0;
          this.timeline.style.setProperty('--progress', p + '%');
        });
        this.video.addEventListener('ended', () => this.classList.remove('is-playing'));
        this._observe();
      }
      disconnectedCallback() {
        if (this._io) { this._io.disconnect(); this._io = null; }
      }
      _observe() {
        if (this._io || this.dataset.autoplay !== 'true' || !('IntersectionObserver' in window)) return;
        this._io = new IntersectionObserver((entries) => entries.forEach((en) => {
          if (en.isIntersecting) { this.video.play().catch(() => {}); }
          else if (this.dataset.inactive === 'pause' || this.classList.contains('is-muted')) { this.video.pause(); }
        }), { threshold: 0.25 });
        this._io.observe(this);
      }
      toggle() {
        const v = this.video;
        if (this.classList.contains('is-muted') && this.dataset.autoplay === 'true') {
          v.muted = false; this.classList.remove('is-muted'); v.currentTime = 0; v.play().catch(() => {}); this.classList.add('is-playing'); return;
        }
        if (v.paused) { v.play().catch(() => {}); this.classList.add('is-playing'); }
        else { v.pause(); this.classList.remove('is-playing'); }
      }
      toggleSound() { this.video.muted = !this.video.muted; this.classList.toggle('is-muted', this.video.muted); }
      pause() { this.video && this.video.pause(); this.classList.remove('is-playing'); }
    }
    customElements.define('hm-video', HmVideo);
  }
  /* <hm-main-atc>: a section "Add to cart" button with no product picked. It presses the product page's own
     add-to-cart button, so the selected variant, quantity and any product-form extras are used. */
  const findMainSubmit = () => {
    const selectors = [
      '[id^="MainProduct-"] product-form form[action*="/cart/add"] button[name="add"]',
      '[id^="MainProduct-"] form[action*="/cart/add"] [type="submit"]',
      'product-form.product-form form[action*="/cart/add"] [type="submit"]',
      'form[action*="/cart/add"][id^="product-form-template"] [type="submit"]',
      'product-info form[data-type="add-to-cart-form"] [type="submit"]'
    ];
    for (const selector of selectors) {
      const found = Array.from(document.querySelectorAll(selector)).find((el) => !el.closest('hm-main-atc, .hm-atc'));
      if (found) return found;
    }
    return null;
  };
  window.HM = window.HM || {};
  window.HM.findMainSubmit = findMainSubmit;

  if (!customElements.get('hm-main-atc')) {
    class HmMainAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button || this.dataset.bound) return;
        this.dataset.bound = 'true';
        if (!this._clickBound) {
          this._clickBound = true;
          this.button.addEventListener('click', (event) => this.onClick(event));
        }
        this.sync();
        // variant changes re-render the main button asynchronously, so re-check shortly after too
        this.onChange = () => { window.requestAnimationFrame(() => this.sync()); window.setTimeout(() => this.sync(), 700); };
        document.addEventListener('change', this.onChange);
      }
      disconnectedCallback() {
        if (this.onChange) document.removeEventListener('change', this.onChange);
        delete this.dataset.bound;
      }
      sync() {
        const target = findMainSubmit();
        if (!target) return;
        const unavailable = target.disabled || target.getAttribute('aria-disabled') === 'true';
        if (!target.classList.contains('loading')) this.button.disabled = unavailable;
      }
      onClick(event) {
        event.preventDefault();
        const target = findMainSubmit();
        if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
        this.button.classList.add('loading');
        target.click();
        const done = () => this.button.classList.remove('loading');
        const watcher = new MutationObserver(() => {
          if (!target.classList.contains('loading')) { done(); watcher.disconnect(); }
        });
        watcher.observe(target, { attributes: true, attributeFilter: ['class'] });
        window.setTimeout(() => { done(); watcher.disconnect(); }, 4000);
      }
    }
    customElements.define('hm-main-atc', HmMainAtc);
  }

  /* [data-hm-main-atc] buttons (vertical ticker, comparison slider/results, content tabs): one delegated handler that
     clicks the product page's own add-to-cart button once. */
  if (!window.__hmMainAtcBound) {
    window.__hmMainAtcBound = true;
    document.addEventListener('click', (event) => {
      const btn = event.target.closest && event.target.closest('[data-hm-main-atc]');
      if (!btn || btn.closest('hm-main-atc')) return;
      event.preventDefault();
      const target = findMainSubmit();
      if (target && !target.disabled && target.getAttribute('aria-disabled') !== 'true') target.click();
    });
  }

  // Generic: pause videos inside a container (used by sliders on slide change)
  window.HM = window.HM || {};
  window.HM.pauseVideosIn = (root) => root && root.querySelectorAll('hm-video').forEach((v) => v.pause && v.pause());
})();
